import { OperationMode } from './operation-mode';

export class ToolSettingMode {
  constructor(
    public hash?: string,
    public mode?: OperationMode,
    public modeName?: string,
    public vibration?: number,
    public power?: number
  ) { }

  clone() {
    return new ToolSettingMode (
      this.hash,
      this.mode,
      this.modeName,
      this.vibration,
      this.power
    );
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/tool-setting-mode.ts